import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ChannelContext, DESIGN_STANDARD } from '@/modules/ChannelList/constants/carousels';

import { ChannelType } from '@/modules/common/types/channel';
import { ChannelConfig } from '@/modules/common/types/configuration';

import { deepMergeChannel } from '@/modules/common/helpers/configuration';
import * as commonSelectors from '@/modules/common/redux/selectors/common';

type Props = {
  id?: ChannelType['id'];
  design?: ChannelType['design'];
  children: React.ReactNode;
};

function ChannelConfiguration({ children, id, design }: Props) {
  const configuration = useSelector(commonSelectors.configurationSelector);

  const config = useMemo<ChannelConfig>(() => {
    let configByChannel = configuration.modules.channelList.channels.byType[design ?? DESIGN_STANDARD] as ChannelConfig;

    const extraSettings = id ? configuration.modules.channelList.channels.byId[id] : undefined;

    if (extraSettings) {
      configByChannel = deepMergeChannel(configByChannel, extraSettings);
    }

    return configByChannel;
  }, [id, design, configuration]);

  return <ChannelContext.Provider value={config}>{children}</ChannelContext.Provider>;
}

export default ChannelConfiguration;
